import {get as _get} from 'lodash';
import {REHYDRATE} from 'redux-persist/lib/constants';

import * as actionTypes from '@actions/actionTypes';
import {mergeRehydrate} from '@reducers/rehydrateUtils';

const initialState = {};

const menu = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.MENU_STORE: {
            return {
                ...state,
                active: action.key,
                opened: action.key,
            };
        }
        case actionTypes.MENU_SAVE: {
            return {
                ...state,
                opened: action.key,
            };
        }
        case actionTypes.MENU_TOGGLE: {
            return {
                ...state,
                expanded: action.key,
            };
        }
        case actionTypes.SET_REDIRECT_LOADER_VISIBILITY: {
            return {
                ...state,
                isRedirectLoaderVisible: action.params.isRedirectLoaderVisible,
                redirectError: _get(action, 'params.redirectError', state.redirectError),
            };
        }

        case REHYDRATE: {
            return {
                ...state,
                ...mergeRehydrate(action, 'payload.app.menu', initialState),
                isRedirectLoaderVisible: false,
                redirectError: false,
            };
        }

        default:
            return state;
    }
};

export default menu;
